import { Component, Input, OnInit } from '@angular/core';
import IZoningCodeMetaData = ZoningAPI.IZoningCodeMetaData;

@Component({
    standalone: false,
    selector: 'app-zc-prs-statistic',
    templateUrl: './zc-prs-statistic.component.html',
    styleUrls: ['./zc-prs-statistic.component.scss']
})
export class ZcPrsStatisticComponent implements OnInit {
    @Input()
    metaData: IZoningCodeMetaData;

    constructor() {}

    get noData(): boolean {
        return (
            !this.metaData ||
            (!this.metaData.gapiPRsCount &&
                !this.metaData.cachedPRs &&
                !this.metaData.notCachedPRsCount &&
                !this.metaData.prsCachingProgress)
        );
    }

    ngOnInit(): void {}
}
